/* Love N Care — hero: video autoplay + subtle parallax, and carousel crossfade/autoplay/progress. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Poster-first hero video: the markup ships no <source>; pick the rendition for this
     device once the page has loaded so the file never competes with the LCP poster,
     fonts or product images. Phones get 480p (720p/1080p on tablet/desktop), Safari gets
     the adaptive HLS stream, and reduced-motion / Save-Data / 2G-3G stay on the poster. */
  function attachSource(vid) {
    if (vid.dataset.lncSrcDone) return; vid.dataset.lncSrcDone = '1';
    var conn = navigator.connection || {};
    if (reduce || conn.saveData) return;
    var w = window.innerWidth || 1024;
    var src = '';
    /* getAttribute, not dataset: data-src-480 has no camelCase form (dataset drops the hyphen only before letters) */
    var s480 = vid.getAttribute('data-src-480') || '', s720 = vid.getAttribute('data-src-720') || '', s1080 = vid.getAttribute('data-src-1080') || '', sHls = vid.getAttribute('data-src-hls') || '';
    /* HLS only where it is native and proven: iOS/iPadOS, Safari, Android Chrome. Desktop
       Chrome/Edge/Firefox answer "maybe" in some builds but cannot play it — they get MP4. */
    var ua = navigator.userAgent || '';
    var nativeHls = /iPhone|iPad|iPod|Android/i.test(ua) || (/Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR/i.test(ua));
    /* Phones always get the fixed 480p MP4 (~2.6 MB for the 14 s loop): adaptive HLS would
       climb to the 1080p ladder on any decent connection and pull the full 12 MB. Tablets and
       desktops on Safari/iPad get HLS; desktop Chrome/Edge/Firefox get 720p/1080p MP4. */
    if (w < 750) src = /(slow-2g|2g|3g)/.test(conn.effectiveType || '') ? '' : s480;
    else if (sHls && nativeHls && vid.canPlayType('application/vnd.apple.mpegurl')) src = sHls;
    else if (w < 990) src = s720;
    else src = s1080;
    if (!src) return;
    var s = document.createElement('source');
    s.src = src;
    s.type = src.indexOf('.m3u8') > -1 ? 'application/vnd.apple.mpegurl' : 'video/mp4';
    /* A derived rendition URL that does not exist errors on the <source>: fall back to the 1080p file. */
    if (src !== s1080 && s1080) {
      s.addEventListener('error', function () {
        if (vid.dataset.lncFallback) return; vid.dataset.lncFallback = '1';
        s.remove();
        var f = document.createElement('source'); f.src = s1080; f.type = 'video/mp4';
        vid.appendChild(f); vid.load();
        var q = vid.play(); if (q && q.catch) q.catch(function () {});
      }, { once: true });
    }
    vid.appendChild(s);
    vid.load();
    var p = vid.play(); if (p && p.catch) p.catch(function () {});
  }
  function afterLoad(fn) {
    var run = function () { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 }); else setTimeout(fn, 250); };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function initVideo(hero) {
    if (hero.dataset.lncVid) return; hero.dataset.lncVid = '1';
    var vid = hero.querySelector('.lnc-hero__video video');
    // A hero that is hidden when the page has loaded (standing down for a sale band or the Sydney-only Warehouse
    // Sale band) never downloads its video.
    if (vid && vid.hasAttribute('data-lnc-video')) afterLoad(function () { if (vid.getClientRects().length) attachSource(vid); });
    else if (vid) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    if (reduce) return;
    var inner = hero.querySelector('.lnc-hero__inner--center');
    var media = hero.querySelector('.lnc-hero__video');
    var cue = hero.querySelector('.lnc-hero__cue');
    var raf = null;
    /* Design parallax (index.html frame()): content floats UP at -0.42y and fades over 60% of the
       hero; the video slow-zooms (+12%) while drifting down at 0.06y; the scroll cue fades in 150px. */
    function frame() {
      var y = window.scrollY || 0;
      var h = hero.offsetHeight || window.innerHeight;
      if (y <= h + 60) {
        if (inner) {
          inner.style.transform = 'translate3d(0, ' + (y * -0.42).toFixed(1) + 'px, 0)';
          inner.style.opacity = Math.max(0, 1 - y / (h * 0.6)).toFixed(3);
        }
        if (media) {
          media.style.transform = 'scale(' + (1 + Math.min(y / h, 1) * 0.12).toFixed(3) + ') translate3d(0, ' + (y * 0.06).toFixed(1) + 'px, 0)';
        }
        if (cue) cue.style.opacity = Math.max(0, 1 - y / 150).toFixed(3);
      }
      raf = null;
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(frame); }
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* Carousel (7 Oct 2026 rewrite, owner: "the gold line reaches the end but the slide doesn't change"):
     the slide now advances on the progress bar's own transitionend, so the change lands exactly when the
     gold line finishes — the old setInterval drifted from the bar while the page was still busy loading
     (slide 1 overstayed, then slide 2 came early). The first slide waits for its image. Hover pauses only
     for a real mouse (a tap on a phone fired mouseenter and froze the timer while the bar kept running),
     and the bar freezes with it; a hidden tab pauses too. */
  function initCarousel(car) {
    if (car.dataset.lncCar) return; car.dataset.lncCar = '1';
    var scenes = [].slice.call(car.querySelectorAll('[data-scene]'));
    var dots = [].slice.call(car.querySelectorAll('[data-dot]'));
    var bar = car.querySelector('[data-bar]');
    var ms = parseInt(car.dataset.autoplay || '0', 10);
    if (scenes.length < 2) { if (bar) bar.style.width = '100%'; return; }
    var auto = !!(ms && !reduce);
    var i = 0, cycle = 0, timer = null, paused = false, pausedPct = 0, started = false;

    function setBar(fromPct, dur) {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.width = fromPct + '%';
      void bar.offsetWidth; // commit the reset before animating again
      if (dur > 0) { bar.style.transition = 'width ' + dur + 'ms linear'; bar.style.width = '100%'; }
    }
    function run(fromPct) {
      var dur = Math.max(250, Math.round(ms * (1 - fromPct / 100)));
      var c = ++cycle;
      setBar(fromPct, dur);
      clearTimeout(timer);
      // safety net only — the bar's transitionend normally advances first
      timer = setTimeout(function () { advance(c); }, bar ? dur + 600 : dur);
    }
    function advance(c) { if (c === cycle && !paused) show(i + 1); }
    function show(n) {
      i = (n + scenes.length) % scenes.length;
      scenes.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (!auto) { if (bar) bar.style.width = '100%'; return; }
      if (paused) { pausedPct = 0; cycle++; clearTimeout(timer); setBar(0, 0); return; }
      run(0);
    }
    function pause() {
      if (!auto || paused || !started) return;
      paused = true; cycle++; clearTimeout(timer);
      if (bar && bar.parentElement) {
        var w = bar.getBoundingClientRect().width, full = bar.parentElement.getBoundingClientRect().width || 1;
        pausedPct = Math.min(99, (w / full) * 100);
        setBar(pausedPct, 0);
      }
    }
    function resume() {
      if (!auto || !paused) return;
      paused = false;
      run(pausedPct);
    }
    if (bar) bar.addEventListener('transitionend', function (e) { if (e.propertyName === 'width') advance(cycle); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.dot, 10)); }); });
    car.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(); });
    car.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resume(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else if (!car.matches(':hover')) resume(); });

    // first slide: start the clock once its image is ready (or after 2.5 s), so slide 1 gets its full time
    function kick() {
      if (started) return; started = true; show(0);
      // opened in a background tab: animations don't run there — wait, and start fresh when it's shown
      if (document.hidden) pause();
      else if (window.matchMedia && matchMedia('(hover: hover)').matches && car.matches(':hover')) pause();
    }
    scenes.forEach(function (s, k) { s.classList.toggle('is-active', k === 0); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === 0); });
    if (bar) setBar(0, 0);
    var firstImg = scenes[0].querySelector('img');
    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', kick, { once: true });
      firstImg.addEventListener('error', kick, { once: true });
      setTimeout(kick, 2500);
    } else kick();
  }

  function init(root) {
    (root || document).querySelectorAll('.lnc-hero--video[data-hero]').forEach(initVideo);
    (root || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
